/* Security sheet page (/pages/masterclass-security).

   Two jobs, both lifted out of the source file's inline handler and inline <script> so
   the page carries no inline JS:

   1. The print button. The whole point of the page replacing a PDF is that a reader can
      still produce a one-sheet A4 file of the CURRENT terms on demand.
   2. The retrieval date stamp. A page cannot go stale the way a mailed PDF does, but it
      can still be printed and filed — so the printed copy says when it was taken. */
(function () {
  'use strict';

  document.addEventListener('click', function (event) {
    if (event.target.closest('[data-print-sheet]')) window.print();
  });

  function init() {
    var stamp = document.getElementById('dm-printed');
    if (!stamp) return;
    /* ISO date: unambiguous for a document read in several countries. */
    var today = new Date().toISOString().slice(0, 10);
    stamp.textContent = 'retrieved ' + today + ' from dreammachine.systems/pages/masterclass-security';
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
